<template>
  <v-toolbar-items class="toolbar-container">
    <router-link :to="{name: 'VisitsPage'}">
      <HeaderButton :button-text="$t('header.planVisit')" />
    </router-link>
    <router-link :to="{name: 'ProfilePage'}">
      <HeaderButton :button-text="$t('header.profile')" />
    </router-link>
    <router-link :to="{name: 'PetsPage'}">
      <HeaderButton :button-text="$t('header.pets')" />
    </router-link>
    <HeaderButton
      :button-text="$t('header.logout')"
      class="header-logout-button"
      @click="$emit('logout')"
    />
  </v-toolbar-items>
</template>
<script>
import HeaderButton from './HeaderButton'

export default {
  name: 'NotResponsiveNavigation',
  components: {
    HeaderButton,
  },
}
</script>
<style scoped>
a {
  text-decoration: none;
}

a.router-link-active >>> .v-btn__content {
  color: var(--v-primary-base);
}

.toolbar-container >>> .v-ripple__container {
  opacity: 0;
}

.header-logout-button {
  margin-left: 100px !important;
  margin-right: 30px !important;
}
</style>
